import { useGetUserAgent as useGetUserAgentCore } from '@cash-rewards/reactjs';

import { useAppContext } from '@/modules/core/providers/appConfigProvider';

export default function useGetUserAgent() {
  const { uaString } = useAppContext();

  return useGetUserAgentCore(uaString as string);
}
